<!-- <p>notification-table works!</p> -->

<mat-card class="one-card-flat" oneCard style="position:relative">
  <div class="notification-overview-table">
    <one-table>
     <one-table-content>
        <mat-table [dataSource]="dataSource" class="no-table" matSort multiTemplateDataRows>
          <ng-container matColumnDef="Type">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
            <mat-cell *matCellDef="let element" [title]="element.Type"><div class="truncate-text" >{{ element.Type }}</div></mat-cell>
          </ng-container>
  
          <ng-container matColumnDef="GlobalId">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Global ID</mat-header-cell>
            <mat-cell *matCellDef="let element" [title]="element.GlobalId"><div class="truncate-text">{{ element.GlobalId }}</div>           
            </mat-cell>
          </ng-container>
       
          <ng-container matColumnDef="LocalId">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Local ID</mat-header-cell>
            <mat-cell *matCellDef="let element" [title]="element.LocalId"><div class="truncate-text">{{ element.LocalId }}</div></mat-cell>
          </ng-container>

          <ng-container matColumnDef="Country">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Country</mat-header-cell>
            <mat-cell *matCellDef="let element" [title]="element.Country"><div class="truncate-text">{{ element.Country }}</div>           
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Title">
            <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
            <mat-cell *matCellDef="let element" [title]="element.Title"><div class="truncate-text">{{ element.Title }}</div></mat-cell>
          </ng-container>

          <ng-container matColumnDef="CreationDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Date Created</mat-header-cell>
            <mat-cell *matCellDef="let element" [title]="element.CreationDate"><div class="truncate-text">{{ appUtil.formatDateWithTime(element.CreationDate) }}</div></mat-cell>
          </ng-container>
    
          <ng-container matColumnDef="Status" style="display: flex;">
            <mat-header-cell *matHeaderCellDef>
              Status</mat-header-cell>
            <mat-cell *matCellDef="let element" [title]="element.Status" style="justify-content: space-between;">  
              <mat-chip class="notification-list-source-chip truncate-text" oneChip oneChipAppearance="outline">
                  <img src="assets/{{notificationStatusIcon[element.Status]}}" class="chip-icon">
                {{ element.Status }}</mat-chip>            
                <i class="one-icons" (click)="openNotificationDetails(element)">
                  arrow_right
                  </i>   
              </mat-cell> 
          </ng-container>
  
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ checked: selection.isSelected(row), disabled: row.disabled }"
            class="one-element-row" (click)="openNotificationDetails(row)"
          ></mat-row>
        </mat-table>
      </one-table-content>
  
      <one-table-footer *ngIf="userPermission.CreateNotification || userPermission.SendNotification">
        <button color="primary" mat-flat-button (click)="openLocalNotificationDialog()">Create Local Notification</button>
      </one-table-footer>
    </one-table>
    <div class="noDataView" *ngIf="!initPageLoad; else showLoading">
      <ng-container *ngIf="tableData.length < 1; else noFilteredData">
        No data available.
      </ng-container>
      <ng-template #noFilteredData>
        <ng-container *ngIf="dataSource.data.length < 1; else noSearchedData">
          No data available with given filter criteria.
        </ng-container>
        <ng-template #noSearchedData>
          <ng-container *ngIf="dataSource.filteredData.length < 1">
            No data available with given search criteria.
          </ng-container>
        </ng-template>
      </ng-template>
    </div>
    <ng-template #showLoading>
      <div class="noDataView" *ngIf="dataSource.data.length < 1">
        Fetching data...
      </div>
    </ng-template>
  </div>
</mat-card>
  
  